
import React from "react";
import { Link } from "react-router-dom";
import warriorForeground from "../assets/warriorForeground.png";
import skyPlate from "../assets/CnVSkyPlate.png";
import cloudLayer from "../assets/CnVCloudLayer.png";
import birdFlock from "../assets/CnVDistantBirdFlock.svg";
import heroLogo from "../assets/CnVLogoHero.svg";

const HeroSection = () => {
    return (
        <section className="hero-section">
            <div
                className="hero-background"
                aria-hidden="true"
                style={{ backgroundImage: `url(${skyPlate})` }}
            />
            <div className="hero-cloud-viewport" aria-hidden="true">
                <div className="hero-cloud-track">
                    <img src={cloudLayer} alt="" className="hero-cloud-tile" />
                    <img src={cloudLayer} alt="" className="hero-cloud-tile" />
                </div>
            </div>
            <div className="hero-flock" aria-hidden="true">
                <img src={birdFlock} alt="" />
            </div>
            <div className="hero-content">
                <img
                        src={heroLogo}
                        alt="Conquest & Virtue"
                        className="hero-brand"
                    />
                <p>
                    Build your economy, command your armies, and work
                    with your alliance to conquer rival alliances and 
                    secure victory in
                    a persistent multiplayer strategy world.
                </p>
                <Link to="/register" className="hero-cta">
                    Play the Alpha
                </Link>
            </div>
            <img
                src={warriorForeground}
                alt="Warrior"
                className="hero-warrior"
            />
        </section>
    );
};

export default HeroSection;
